import { DragController } from "../drag_controller";
import { mod } from "../utils";

/**
 * Adds an image editor for the faceplate and image upload functions.
 */
export class ImageEditorComponent {
  constructor(controller) {
    this.controller = controller;
    this.active = false;
    this.flipH = 0;
    this.flipV = 0;
    this.rotation = 0;
    this.x = 0;
    this.y = 0;
    this.scale = 1;
    this.$ui = $('#image-controls');
    this._initialized = false;
    this.$designer = $(".canvas-container");
    this.canvasOffsetDrag = new DragController(this.$designer, "canvas", (c, d) => {
      this.x += d.dx;
      this.y += d.dy;
      this.update();
    });
  }

  async init() {
    if (this._initialized) {
      return;
    }
    const me = this;
    this.$rot = this.$ui.find('.rotation');
    this.$scale = this.$ui.find('.scale');
    this.$flipH = this.$ui.find('.flip-horizontal');
    this.$flipV = this.$ui.find('.flip-vertical');

    this.rotControl = new DragController(this.$rot, 'rotation', (c, d) => {
      if (!me.active) { return; }

      let height = c.$ui.height();
      me.rotation -= Math.floor(d.dy);
      me.rotation = mod(me.rotation, 360);

      me.$rot.find('.wheel').css('transform', `rotate(${me.rotation}deg)`);
      me.update();
    });

    this.rotControl.attachHandlers();

    this.scaleControl = new DragController(this.$scale, 'scale', (s, d) => {
      if (!me.active) { return; }

      let height = s.$ui.height();
      this.scale += -d.dy / 80;
      if (this.scale > 3) { this.scale = 3; }
      if (this.scale < .25) { this.scale = .25; }
      let needleHeight = me.$scale.find('.needle').height();
      let uiScale = (this.scale - .25) / 2.75;
      me.$scale.find('.needle').css('top', `${(1 - uiScale) * 100}%`);
      me.update();
    });

    this.scaleControl.attachHandlers();


    this.$flipH.click(function () {
      if (!me.active) { return; }

      $(this).toggleClass('active');
      me.flipH = $(this).hasClass('active') ? 1 : 0;
      me.update();
    })

    this.$flipV.click(function () {
      if (!me.active) { return; }

      $(this).toggleClass('active');
      me.flipV = $(this).hasClass('active') ? 1 : 0;
      me.update();
    })

    this._initialized = true;
  }

  setValues(transform = {}) {
    this.flipH = transform.flipH ? 1 : 0;
    this.flipV = transform.flipV ? 1 : 0;
    this.rotation = mod(transform.rotation || 0, 360);
    this.scale = transform.scale || 1;


    if (this.flipH) {
      this.$flipH.addClass('active');
    } else {
      this.$flipH.removeClass('active');
    }

    if (this.flipV) {
      this.$flipV.addClass('active');
    } else {
      this.$flipV.removeClass('active');
    }


    this.$rot.find('.wheel').css('transform', `rotate(${this.rotation}deg)`);

    let uiScale = (this.scale - .25) / 2.75;
    this.$scale.find('.needle').css('top', `${(1 - uiScale) * 100}%`);

  }

  update() {
    if (this.updateCallback) {
      const transform = {
        flipH: this.flipH,
        flipV: this.flipV,
        scale: this.scale,
        rotation: this.rotation,
        x: this.x || 0,
        y: this.y || 0
      }
      this.updateCallback(transform);
    }
  }

  async show(callback, $activeContainer, side) {
    if (this.active && this.$activeContainer == $activeContainer) {
      return;
    }

    this.$ui.addClass('active');
    $activeContainer.addClass('editor-active');
    this.updateCallback = callback;
    this.$activeContainer = $activeContainer;
    await this.controller.designer.enableControls(false, side);
    const el = await this.controller.designer.getCanvasElement();
    this.canvasOffsetDrag.attachHandlers(el, el);
    this.active = true;
    this.update();
  }

  async hide() {
    if (!this.active) {
      return;
    }

    this.update();
    this.active = false;
    this.$ui.removeClass('active');
    this.$activeContainer.removeClass('editor-active');
    this.$activeContainer = undefined;
    await this.controller.designer.enableControls(true);
    const el = await this.controller.designer.getCanvasElement();
    this.canvasOffsetDrag.detachHandlers(el, el);
    this.updateCallback = undefined;
  }
}